/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection12FoiChanged, m11ReportSection12ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection12Foi, selectM11ReportSection12Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { Button } from "semantic-ui-react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveSupportingDetailsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section12State, setAlertModalState, setStartingSection12State) => {

  let changesStates = {
    section12State: section12State
  };
  let response = await saveM11Changes(apiToken, 42, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection12Resource) {
      dispatch(m11ReportSection12ResourceChanged(response.m11ReportSection12Resource));
    }
    setStartingSection12State(JSON.parse(JSON.stringify(section12State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step042PriorProtocolAmendments = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection12Foi = useSelector(selectM11ReportSection12Foi);
  const m11ReportSection12Resource = useSelector(selectM11ReportSection12Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section12State, setSection12State] = useState({
    "section123Status": "empty", "section123Xhtml": "", "option": ""
  });
  const [startingSection12State, setStartingSection12State] = useState({
    "section123Status": "empty", "section123Xhtml": "", "option": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
  const [remount, setRemount] = useState(1);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section12State, startingSection12State)),
    async saveAllChanges() {
      await saveSupportingDetailsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section12State, setAlertModalState, setStartingSection12State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section123Status": "empty", "section123Xhtml": "", "option": "",
        "loaded": true
      };
      setSection12State(startingData);
      setStartingSection12State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[12]?.entry?.length) {
        let m11ReportSection012Foi = getIdFromReference(m11ReportContainerResource.section[12].entry[0]);
        if (m11ReportSection012Foi && !isNaN(m11ReportSection012Foi) && m11ReportSection012Foi !== m11ReportSection12Foi) {
          dispatch(m11ReportSection12FoiChanged(m11ReportSection012Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection12Foi && !isNaN(m11ReportSection12Foi)) {
      loadResource(m11ReportSection12Foi, "M11ReportSection12", apiToken, dispatch);
    }
  }, [m11ReportSection12Foi]);

  useEffect(() => {
    if (m11ReportSection12Resource && Object.keys(m11ReportSection12Resource).length > 0) {
      let startingData = {
        "section123Status": "empty", "section123Xhtml": "", "option": "",
        "loaded": true
      };
      if (m11ReportSection12Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection12Resource.section[0].section[2]?.text?.div &&
          m11ReportSection12Resource.section[0].section[2].text.status !== "empty") {
          startingData.section123Status = m11ReportSection12Resource.section[0].section[2].text.status;
          startingData.section123Xhtml = m11ReportSection12Resource.section[0].section[2].text.div;
          if (startingData.section123Xhtml.includes("This protocol has not been amended.")) {
            startingData.option = "A";
          }
          if (startingData.section123Xhtml.includes("This is the first protocol amendment.")) {
            startingData.option = "B";
          }
          if (startingData.section123Xhtml.includes("This protocol has been amended previously. The Protocol Amendment Summary of Changes for the current amendment is located directly before the Table of Contents. Prior amendment(s) to this protocol are listed in the table below, beginning with the most recent.")) {
            startingData.option = "C";
          }
        }
        setSection12State(startingData);
        setStartingSection12State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection12Resource]);

  useEffect(() => {
    if (section12State.option === "A" &&
      !section12State.section123Xhtml.includes("This protocol has not been amended.")) {
      setSection12State({
        "section123Status": "generated",
        "section123Xhtml": "<div xmlns=\"http://www.w3.org/1999/xhtml\">This protocol has not been amended.</div>",
        "loaded": true, "option": "A"
      });
    }
    if (section12State.option === "B" &&
      !section12State.section123Xhtml.includes("This is the first protocol amendment.")) {
      setSection12State({
        "section123Status": "generated",
        "section123Xhtml": "<div xmlns=\"http://www.w3.org/1999/xhtml\">This is the first protocol amendment.</div>",
        "loaded": true, "option": "B"
      });
    }
    if (section12State.option === "C" &&
      !section12State.section123Xhtml.includes("This protocol has been amended previously. The Protocol Amendment Summary of Changes for the current amendment is located directly before the Table of Contents. Prior amendment(s) to this protocol are listed in the table below, beginning with the most recent.")) {
      setSection12State({
        "section123Status": "generated",
        "section123Xhtml": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>This protocol has been amended previously. The Protocol Amendment Summary of Changes for the current amendment is located directly before the Table of Contents. Prior amendment(s) to this protocol are listed in the table below, beginning with the most recent.</p>" +
          "<table><tbody>" +
          "<tr><td><strong>Document</strong></td><td><strong>Sponsor Approval Date</strong></td><td><strong>Approximate Enrollment when Sponsor Approved Amendment</strong></td></tr>" +
          "<tr><td>[Enter Amendment Identifier]</td><td>[Enter Sponsor Approval Date]</td><td>Approximately #/% enrolled [Globally, Locally, or By Cohort]</td></tr>" +
          "<tr><td>Original Protocol</td><td>[Enter Sponsor Approval Date]</td><td>0</td></tr>" +
          "</tbody></table>" +
          "<p>The Overview of Changes from each prior protocol amendment is provided below.</p>" +
          "</div>",
        "loaded": true, "option": "C"
      });
    }
    setRemount(prevState => prevState + 1);
  }, [section12State.option]);

  return <div>
    <h3>Complete Section 12.3 Prior Protocol Amendment(s)</h3>
        {!(m11ReportSection12Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 42 (Complete Section 12.3 Prior Protocol Amendment(s)) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section12State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>For an original protocol that has not been amended, click the button:</h4>
          <Button className="formButton navigationButton"
            style={{
              color: "#000000",
              fontSize: "20px",
              width: "100%",
              margin: "0px"
            }}
            content="This protocol has not been amended."
            onClick={() => {
              setSection12State(prevState => {
                return {
                  ...prevState, "option": "A"
                }
              });
            }}
          />
          <h4 style={{ marginBottom: "0px" }}>For the first protocol amendment, click the button:</h4>
          <Button className="formButton navigationButton"
            style={{
              color: "#000000",
              fontSize: "20px",
              width: "100%",
              margin: "0px"
            }}
            content="This is the first protocol amendment."
            onClick={() => {
              setSection12State(prevState => {
                return {
                  ...prevState, "option": "B"
                }
              });
            }}
          />
          <h4 style={{ marginBottom: "0px" }}>For protocols with prior amendment(s), click the button below then edit the details:</h4>
          <Button className="formButton navigationButton"
            style={{
              color: "#000000",
              fontSize: "20px",
              width: "100%",
              margin: "0px"
            }}
            content="This protocol has been amended previously."
            onClick={() => {
              setSection12State(prevState => {
                return {
                  ...prevState, "option": "C"
                }
              });
            }}
          />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 12.3 Prior Protocol Amendment(s) summary as needed.</h4>
          {remount && <TextDivEntry elementName="section123Xhtml" key={remount}
            startingValue={section12State.section123Xhtml}
            setResourceState={setSection12State} />}
        </>}
      </>
    }
  </div >
});

const M11Step042PriorProtocolAmendmentsHelperText = <div>
  <h3>Start Section 12 Supporting Details</h3>
  <div style={{ textAlign: "left" }}>
    <p>For an original protocol that has not been amended:</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Click the "This protocol has not been amended." button.</p>
      <p>Click the 'Save All Changes' button.</p>
    </div>
    <p>For the first protocol amendment:</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Click the "This is the first protocol amendment." button.</p>
      <p>Click the 'Save All Changes' button.</p>
    </div>
    <p>For protocols with prior amendment(s):</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Click the "This protocol has been amended previously." button.</p>
      <p>Revise the Section 12.3 Prior Protocol Amendment(s) summary as needed.</p>
      <p>Previous amendments should appear in reverse chronological order with the most recent at the top (e.g., Amendment 3, 2, 1). Delete or add lines as needed. Inclusion of region-, country-, and site-specific amendments in the table is optional. If included, ensure that the scope is clearly distinguishable from global amendments.</p>
      <p>If including the column with enrollment numbers, follow the instructions below.</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	For global amendments to international clinical trials or amendments to a single-country trial, list the approximate global enrollment total or percentage at the time of the amendment and select “globally”.</p>
        <p>•	For global amendments consolidating only country/region-specific requirements, list approximate local enrollment total or percentage at the time of the amendment and select “locally”. If consolidating a series of local amendments, list the status of all the relevant locations.</p>
        <p>•	For country/region-specific amendments to international clinical trials, list the approximate local enrollment total or percentage at the time of the amendment and select “locally”.</p>
        <p>•	For trials in which enrollment status by cohort is more meaningful, such as for single-site or early-phase studies, listing the approximate enrollment by cohort is an option. If multiple cohorts are ongoing at the time of the amendment, list the status of all the ongoing cohorts.</p>
        <p>•	Enter the approximate number or percentage of participants enrolled as a percentage of the expected total.</p>
      </div>
      <p>For the line that reads "The Overview of Changes from each prior protocol amendment is provided below."</p>
      <div style={{ marginLeft: "24px" }} >
        <p>EITHER Move the Overview of Changes table from the previous amendments to this section in reverse chronological order (most recent first).</p>
        <p>OR Change the 'provided below' phrase to specify the alternative location.</p>
      </div>
      <p>Click the 'Save All Changes' button.</p>
    </div>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step042PriorProtocolAmendmentsValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 42, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 42 (Complete Section 12.3 Prior Protocol Amendment(s)) {validationCheckState.step42numberOfChecks} issues checked. {validationCheckState.step42numberPassed} passed. {validationCheckState.step42numberFailed} failed.</h4>
    <p>Section 12.3 heading is 'Prior Protocol Amendment(s)': {validationCheckState.resultCheckSection123Heading}</p>
    <p>Section 12.3 Prior Protocol Amendment(s) has content: {validationCheckState.resultCheckSection123Content}</p>
    <p>Section 12.3 Prior Protocol Amendment(s) content includes a valid value: {validationCheckState.resultCheckSection123ContentDetail}</p>
  </div>}  </div>
}

export default M11Step042PriorProtocolAmendments;
export { M11Step042PriorProtocolAmendmentsHelperText, M11Step042PriorProtocolAmendmentsValidationCheck };